export enum StorageContentType {
  Profile = 'profile-images',
  Achievements = 'achievements',
  Banner = 'banners',
  ContestBannerImages = 'banner-images',
  ContestCardImages = 'card-images',
  ChartThumbnails = 'chart-thumbnails',
  PositionChartImages = 'position-chart-images',
  Playbook = 'playbook-images',
  HeaderMenuImages = 'header-menu-images',
  AffiliateBanner = 'affiliate-banner',
  AffiliateDashboardBanner = 'affiliate-dashboard-banner',
  ReleaseImages = 'release-images',
}

export enum PublicAssetsContentType {
  Notes = 'notes',
  ShareInTradeTalk = 'Share in TradeTalk',
  ShareInSocial = 'Share in Social',
}

export type AssetsContentType = StorageContentType | PublicAssetsContentType;
export interface FolderImageType {
  name: string;
  link: string;
}

export type FileType = { buffer: string; mimetype: string };
